import React from 'react';
import { useState, useEffect } from 'react';
import { Row, Col, Switch, Form, Button, Card, Select, Input } from 'antd';

import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import errorMessage from 'global_config/error_messages';
import { buttonNames } from '../settings';
import { fetchLabAnalizer } from '../../../../../services/settings/labAnalyzer';

function DynamicFormAnalyzer({
	handleAnalyzerValue,
	handleExistingData,
	newAnalyzerIsTrue,
	resetAnalyzerIsTrue,
}) {
	const [data, setdata] = useState(null);
	// const [resetAnalyzerInput , setResetAnalyzerInput] = useState(true)
	const [optionAnalyzerData, setOptionAnalyzerData] = useState(null);
	const [analyzerInput, setAnalyzerInput] = useState([
		{
			analyzerID: null,
			analyzerName: '',
			examItemAnalyzerCode: '',
		},
	]);

	// for update analyzer data
	useEffect(() => {
		if (newAnalyzerIsTrue) {
			// Always update when newAnalyzerIsTrue is set
			if (handleExistingData && handleExistingData.length > 0) {
				setAnalyzerInput([...handleExistingData]);
			} else {
				// Clear to default when no data or null
				setAnalyzerInput([
					{
						analyzerID: null,
						analyzerName: '',
						examItemAnalyzerCode: '',
					},
				]);
			}
		}
	}, [newAnalyzerIsTrue, handleExistingData]);

	// for reset state analyzerInput after submit data
	useEffect(() => {
		if (resetAnalyzerIsTrue) {
			setAnalyzerInput([
				{
					analyzerID: null,
					analyzerName: '',
					examItemAnalyzerCode: '',
				},
			]);
		}
	}, [resetAnalyzerIsTrue]);

	useEffect(() => {
		getAnalyzerData();
		handleAnalyzerValue(analyzerInput);
	}, [analyzerInput]);

	// fecth analyzer data and convert to Select Dropdown
	const getAnalyzerData = async () => {
		const fetchData = await fetchLabAnalizer();
		const activeAnalyzers = fetchData.filter(item => item.active === 1);
		const changeName = activeAnalyzers.map((item, index) => ({
			id: item.analyzerID,
			label: item.analyzerName,
			value: item.analyzerName,
		}));

		setdata(fetchData);
		setOptionAnalyzerData(changeName);
	};

	// this is use to save input value
	const handleinputchange = (e, index) => {
		const { name, value } = e.target;
		const list = [...analyzerInput];
		list[index][name] = value;
		setAnalyzerInput(list);
	};

	// this is use to save selected value
	const handleselectchange = (e, index) => {
		const found = data.find(obj => {
			return obj.analyzerName === e;
		});
		const list = [...analyzerInput];
		list[index]['analyzerName'] = e;
		list[index]['analyzerID'] = found.analyzerID;
		setAnalyzerInput(list);
	};

	// This is use to remove dynamic field which corresponds
	const handleremove = index => {
		const list = [...analyzerInput];
		list.splice(index, 1);
		setAnalyzerInput(list);
	};

	// This is use to add a dynamic field
	const handleAddCard = () => {
		setAnalyzerInput([
			...analyzerInput,
			{
				analyzerID: null,
				analyzerName: '',
				examItemAnalyzerCode: '',
			},
		]);
	};

	return (
		<Form>
			<p>EXAM RESULT ANALYZER CODE</p>
			{analyzerInput.map((field, index) => (
				<Card size="small" key={index} style={{ marginTop: '15px' }}>
					<div
						style={{
							width: '100%',
							display: 'flex',
							justifyContent: 'space-between',
							alignContent: 'center',
							gap: '15px',
						}}
					>
						<Form.Item style={{ width: '50%' }}>
							<p>ANALYZER</p>

							<Select
								placeholder="ANALYZER"
								options={optionAnalyzerData}
								// loading={isInitializing}
								onChange={e => handleselectchange(e, index)}
								style={{ width: '100%' }}
								value={field.analyzerName}
							/>
						</Form.Item>
						<Form.Item style={{ width: '50%' }}>
							<div
								style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}
							>
								<p>CODE</p>
								<MinusCircleOutlined
									className="dynamic-delete-button"
									style={{ top: '0px' }}
									// onClick={existingData}
									onClick={() => handleremove(index)}
								/>
							</div>

							<Input
								name="examItemAnalyzerCode"
								maxLength={20}
								onChange={e => handleinputchange(e, index)}
								value={field.examItemAnalyzerCode}
							/>
						</Form.Item>
					</div>
				</Card>
			))}

			<Form.Item>
				<Button type="dashed" onClick={handleAddCard} style={{ width: '100%', marginTop: '15px' }}>
					<PlusOutlined /> {buttonNames.addField}
				</Button>
			</Form.Item>
		</Form>
	);
}

export default DynamicFormAnalyzer;
